import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ActiveOrderDsService } from '@app/core/data-services';
import { ArticleClassification, MeasurementService, ProductType } from 'chronos-core-client';
import { AppSettingsQuery } from 'chronos-shared';
import { Quantity } from 'projects/chronos-core-client/src/lib/api/models/quantity';

@Component({
  selector: 'app-waste-assignment-scale',
  templateUrl: './waste-assignment-scale.component.html',
  styleUrls: ['./waste-assignment-scale.component.scss']
})
export class WasteAssignmentScaleComponent implements OnInit {
  @Output() quantityChanged = new EventEmitter<Quantity>();

  public weight: Quantity = { value: 0, unitId: '' };
  public weightDifference: Quantity = { value: 0, unitId: '' };
  public quantity: Quantity = { value: 0, unitId: '' };

  public requestScaleValueLoading: boolean = false;
  public isWeightScaleEnabled: boolean = false;

  constructor(
    private readonly measurementService: MeasurementService,
    private readonly appSettingsQuery: AppSettingsQuery,
    private readonly activeOrderDsService: ActiveOrderDsService
  ) {}

  public ngOnInit(): void {
    this.activeOrderDsService.getActiveProductionOrder().subscribe((order) => {
      this.isWeightScaleEnabled = order.isWasteScaleEnabled;
    });
  }

  public isScaleDisabled(): boolean {
    return this.requestScaleValueLoading;
  }

  public retrieveScaleMeasurement(): void {
    console.info('Retrieving scale measurement…');

    const workCenter = this.appSettingsQuery.getWorkCenter();

    this.requestScaleValueLoading = true;
    this.measurementService.requestScaleValue({ workCenterId: workCenter.id }).subscribe({
      next: (value) => {
        console.info('Scale measurement retrieved:', value);
        if (!value) {
          this.weight = { value: 0, unitId: '' };
          this.weightDifference = { value: 0, unitId: '' };
          this.quantity = { value: 0, unitId: '' };
          return;
        }

        this.weight = value.weight;
        this.weightDifference = value.weightDifference;
        this.quantity = value.quantity;
        this.quantityChanged.emit(this.quantity);
      },
      error: (error) => {
        console.error('Error retrieving scale measurement:', error);
        this.requestScaleValueLoading = false;
      },
      complete: () => {
        this.requestScaleValueLoading = false;
      }
    });
  }
}
